/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */
import React from "react";
import { View } from "react-native";

import { skalePrimaryBlue, skaleTextDarkGray } from "config/UpduoColors";
import { Text } from "UpduoLibrary";

export default function TermsConditionsText() {
  return (
    <View
      style={{
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        marginVertical: 30,
      }}
    >
      <Text
        style={{ fontSize: 14, color: skaleTextDarkGray, textAlign: "center" }}
      >
        {"By continuing, you agree to Upduo's\n"}
        <a
          style={{
            color: skalePrimaryBlue,
            fontSize: 14,
            textDecoration: "none",
          }}
          href={"https://www.upduo.com/terms"}
        >
          {"Terms of Service"}
        </a>
        {" and "}
        <a
          style={{
            color: skalePrimaryBlue,
            fontSize: 14,
            textDecoration: "none",
          }}
          href={"https://www.upduo.com/privacy"}
        >
          {"Privacy Policy"}
        </a>
        {"."}
      </Text>
    </View>
  );
}
